import React from "react";
import { MapPin, Bookmark, Eye, Check } from "lucide-react";

export default function CandidateCard({ candidate: c, onView, onToggleSave, selectable, selected, onToggleSelect }) {
  return (
    <div data-testid="candidate-card" className={`relative rounded-2xl liquid-glass p-5 transition-colors flex flex-col ${selected ? "border-teal-500/60 ring-1 ring-teal-500/40" : "hover:border-teal-500/30"}`}>
      {selectable && (
        <button onClick={() => onToggleSelect(c)} data-testid="candidate-select-checkbox"
          className={`absolute top-3 left-3 w-5 h-5 rounded-md border flex items-center justify-center transition-colors z-10 ${selected ? "bg-teal-400 border-teal-400 text-slate-900" : "border-white/30 bg-slate-950/40 text-transparent hover:border-teal-400"}`}>
          <Check size={13} />
        </button>
      )}
      <div className={`flex items-start justify-between gap-3 ${selectable ? "pl-7" : ""}`}>
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-11 h-11 rounded-full bg-gradient-to-br from-teal-400 to-blue-600 flex items-center justify-center text-sm font-bold text-slate-900 shrink-0">
            {c.name?.[0]?.toUpperCase() || "C"}
          </div>
          <div className="min-w-0">
            <div className="font-semibold text-slate-100 truncate">{c.name}</div>
            <div className="text-xs text-slate-400 truncate">{c.headline || "Candidate"}</div>
          </div>
        </div>
        {typeof c.match_score === "number" && (
          <span data-testid="candidate-match-score" className="shrink-0 font-mono text-sm text-teal-300 bg-teal-500/10 border border-teal-500/25 rounded-full px-2.5 py-0.5">{c.match_score}%</span>
        )}
      </div>
      {c.location && <div className="mt-3 flex items-center gap-1.5 text-xs text-slate-400"><MapPin size={13} /> {c.location}</div>}
      <div className="mt-3 flex flex-wrap gap-1.5 min-h-[1.5rem]">
        {(c.skills || []).slice(0, 5).map((s) => (
          <span key={s} className="text-[11px] px-2 py-0.5 rounded-full bg-slate-800/80 text-cyan-300 border border-cyan-500/20">{s}</span>
        ))}
      </div>
      <div className="mt-4 flex items-center gap-2">
        <button onClick={() => onView(c)} data-testid="candidate-view-btn"
          className="flex-1 flex items-center justify-center gap-1.5 text-sm py-2 rounded-lg border border-white/10 text-slate-200 hover:bg-white/5 transition-colors">
          <Eye size={15} /> View profile
        </button>
        <button onClick={() => onToggleSave(c)} data-testid="candidate-save-btn"
          className={`flex items-center justify-center gap-1.5 text-sm py-2 px-3 rounded-lg border transition-colors ${c.saved ? "text-teal-300 border-teal-500/40 bg-teal-500/10" : "text-slate-300 border-white/10 hover:bg-white/5"}`}>
          <Bookmark size={15} fill={c.saved ? "currentColor" : "none"} /> {c.saved ? "Saved" : "Save"}
        </button>
      </div>
    </div>
  );
}
